"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const toolkit_1 = require("@reduxjs/toolkit");
const authSlice_1 = require("./authSlice");
const theme_1 = __importDefault(require("../../styles/theme"));
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const labelButton_1 = __importDefault(require("../../components/labelButton/labelButton"));
const utils_1 = require("../../utils/utils");
const analytics_1 = require("../../utils/analytics/analytics");
const constants_1 = require("../../constants/constants");
const screenConstants_1 = require("../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const store_1 = require("../../store");
const input_1 = __importStar(require("../../components/input/input"));
const styles_1 = __importDefault(require("../../styles/styles"));
const textStyles_1 = __importDefault(require("../../components/text/textStyles"));
const SignIn = () => {
    const { message, userEmail } = (0, store_1.useAppSelector)((state) => {
        return {
            message: state.auth.message,
            userEmail: state.auth.email,
        };
    });
    const dispatch = (0, store_1.useAppDispatch)();
    const navigation = (0, useAppNavigation_1.default)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [username, setUsername] = (0, react_1.useState)(userEmail);
    const [password, setPassword] = (0, react_1.useState)('');
    // TODO MOVE THIS TO MIDDLEWARE
    const { setUser } = (0, analytics_1.useAnalytics)();
    const performLogin = async () => {
        setIsLoading(true);
        let result;
        if (react_native_1.Platform.OS !== 'web') {
            const payload = {
                email: username ? username.toString() : '',
                password: password ? password.toString() : '',
                app_version: constants_1.APP_VERSION,
                firebase_id: await (0, analytics_1.getFirebaseUserTokenId)(),
            };
            dispatch((0, authSlice_1.setLoginOrRegister)());
            result = await dispatch((0, authSlice_1.login)(payload));
        }
        else {
            const payload = {
                email: username ? username.toString() : '',
                password: password ? password.toString() : '',
            };
            result = await dispatch((0, authSlice_1.login)(payload));
        }
        logEventWithExtraProperties('api_call', {
            name: 'login',
            status: 'submitted',
            location: 'screen_SignIn',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'login',
                status: 'success',
                location: 'screen_SignIn',
            });
            setUser();
            setIsLoading(false);
            navigation.navigate(screenConstants_1.HOME_SCREEN);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'login',
                status: 'fail',
                location: 'screen_SignIn',
            });
            setErrors(result.payload);
            setIsLoading(false);
        }
    };
    return (react_1.default.createElement(navContainer_1.default, { withLogo: true, titleText: "Welcome Back", errors: errors, message: message, subTitleText: "Login with the detail requested below.", isLoading: isLoading },
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_EMAIL, label: "Email", placeholder: "Your email", setValue: setUsername, value: username, error: (0, utils_1.getError)('email', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PASSWORD, label: "Password", placeholder: "Password", setValue: setPassword, value: password, error: (0, utils_1.getError)('password', errors) }),
        react_1.default.createElement(labelButton_1.default, { title: "Forgot Password?", textColor: theme_1.default.colors.COLOR_PRIMARY, onPress: () => navigation.navigate(screenConstants_1.RECOVER_PASSWORD_SCREEN), disabled: false, eventName: "navigate_recoverPassword", positionStyle: [styles_1.default.flexDirectionRow, styles_1.default.justifyFlexEnd] }),
        react_1.default.createElement(primaryButton_1.default, { disabled: false, title: "Login", onPress: performLogin, eventName: "perform_login" }),
        react_1.default.createElement(labelButton_1.default, { title: "Create Account", onPress: () => navigation.navigate(screenConstants_1.ESTIMATE_LOAN_SCREEN), disabled: false, textColor: theme_1.default.colors.COLOR_PRIMARY, eventName: "tap_signIn_createAccount", textBeforeLink: "New to Lendigo? ", positionStyle: [styles_1.default.centerChildHorizontalVertical, styles_1.default.flexDirectionRow], linkStyle: textStyles_1.default.underline })));
};
exports.default = SignIn;
